import React from 'react';
import { Box, Typography, Card, CardContent, useTheme, useMediaQuery } from '@mui/material';
import { School, Work } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

const EducationAndWorkTimeline = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const cardStyle = {
        backgroundColor: '#f4f4f4',
        maxWidth: '100%',
        margin: '0 auto',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    };
    const textStyle = { fontSize: isMobile ? '14px' : undefined };

    const timelineItemStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: isMobile ? '100%' : '80%', // Ensure width consistency
        margin: '0 auto',
    };

    return (
        <Box sx={{ p: 4, backgroundColor: 'white' }}>
            <Typography variant="h4" gutterBottom component="div" sx={{
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: isMobile ? '30px' : '50px',
                color: 'black'
            }}>
                Education <span style={{ color: '#f9004d' }}>&</span> Work Experience
            </Typography>
            <Timeline position={isMobile ? "right" : "alternate"}>
                <TimelineItem sx={timelineItemStyle}>
                    <TimelineSeparator>
                        <TimelineDot color="primary">
                            <Work />
                        </TimelineDot>
                        {!isMobile && <TimelineConnector style={{ backgroundColor: 'black' }} />} {/* Black connector for larger screens */}
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: isMobile ? 1 : 2 }}>
                        <Card sx={cardStyle}>
                            <CardContent>
                                <Typography variant="h5" gutterBottom fontWeight={'bold'}>Residential Security Office (Northeastern University)</Typography>
                                <Typography sx={textStyle}>
                                    <strong>RSO Proctor</strong> (Part-time) <br/>
                                    June 2024 - Present <br/> <br/>
                                    • Responsible for providing access control at Northeastern University Residence halls. <br/>
                                    • Responsible for providing security to residents and providing basic campus information. <br/>
                                    • Regularly interact with Residential Life, Building services, and NUPD for ensuring a safe environment around residence halls.
                                </Typography>
                            </CardContent>
                        </Card>
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem sx={timelineItemStyle}>
                    <TimelineSeparator>
                        <TimelineDot color="secondary">
                            <School />
                        </TimelineDot>
                        {!isMobile && <TimelineConnector style={{ backgroundColor: 'black' }} />} {/* Black connector for larger screens */}
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: isMobile ? 1 : 2 }}>
                        <Card sx={cardStyle}>
                            <CardContent>
                                <Typography variant="h5" gutterBottom fontWeight={'bold'}>Northeastern University</Typography>
                                <Typography sx={textStyle}>
                                    <strong>Master of Science in Information Systems</strong> (Full-time) <br/>
                                    January 2024 - December 2025 <br/>
                                    • GPA: 3.75/4.0 <br/><br/>
                                    I am pursuing my full-time Master's degree in Information Systems from Northeastern University, Boston, MA.
                                </Typography>
                            </CardContent>
                        </Card>
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem sx={timelineItemStyle}>
                    <TimelineSeparator>
                        <TimelineDot color="primary">
                            <Work />
                        </TimelineDot>
                        {!isMobile && <TimelineConnector style={{ backgroundColor: 'black' }} />} {/* Black connector for larger screens */}
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: isMobile ? 1 : 2 }}>
                        <Card sx={cardStyle}>
                            <CardContent>
                                <Typography variant="h5" gutterBottom fontWeight={'bold'}>Wipro Limited</Typography>
                                <Typography sx={textStyle}>
                                    <strong>Software Engineer </strong> (Full-time)<br/>
                                    October 2021 - November 2021 <br/><br/>
                                    I was working as a Software Engineer at Wipro Ltd for 2 Years and 
                                    I have strong expertise in React, full-stack development, cloud technologies, and CI/CD pipelines.<br/>
                                    I also have three certifications in these areas from my time at Wipro Ltd.
                                </Typography>
                            </CardContent>
                        </Card>
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem sx={timelineItemStyle}>
                    <TimelineSeparator>
                        <TimelineDot color="secondary">
                            <School />
                        </TimelineDot>
                        {!isMobile && <TimelineConnector style={{ backgroundColor: 'black' }} />} {/* Black connector for larger screens */}
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: isMobile ? 1 : 2 }}>
                        <Card sx={cardStyle}>
                            <CardContent>
                                <Typography variant="h5" gutterBottom fontWeight={'bold'}>Mumbai University</Typography>
                                <Typography sx={textStyle}>
                                    <strong>Bachelor's of Science in Information Technology</strong> (Full-time)<br/>
                                    June 2018 - May 2021 <br/>
                                    • GPA: 3.8/4.0 <br/><br/>
                                    I completed my Bachelor's degree in Information Technology in May 2021 from Mumbai University, India.
                                </Typography>
                            </CardContent>
                        </Card>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </Box>
    );
};

export default EducationAndWorkTimeline;
